import { Colors } from "assets/colors";

export const styles: any = {
  mainContainer: {
    margin: "0 1rem"
  },
  container: {
    display: "flex",
    alignItems: "center",
    margin: "1.5rem 0 1rem 0"
  },
  buttonContainer: {
    display: "flex",
    alignItems: "center"
  },
  buttons: {
    color: "white",
    textTransform: "capitalize",
    marginRight: "1rem",
    display: "flex",
    alignItems: "center",
    minWidth: "170px",
    "&:hover": {
      color: Colors.BlackText,
    }
  },
  buttonGreen: {
    color: "white",
    textTransform: "capitalize",
    backgroundColor: Colors.Green,
    marginRight: "1rem",
    display: "flex",
    alignItems: "center",
    minWidth: "110px",
    "&:hover": {
      backgroundColor: Colors.HoverGreen,
      color: "white",
    }
  },
  filterIcon: {
    color: "white",
    backgroundColor: Colors.Green,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "35px",
    width: "35px",
    borderRadius: "5px",
    cursor: "pointer",
    padding: ".5rem",
    "&:hover": {
      backgroundColor: "white",
      color: Colors.Green,
      border: `1px solid ${Colors.Green}`
    }
  },
  SearchIcon: {
    color: "white",
    backgroundColor: Colors.Green,
    height: "36px",
    width: "36px",
    borderRadius: "5px",
    cursor: "pointer",
    padding: ".5rem",
    margingLeft: "15px",
    marginTop: "5px",
    "&:hover": {
      backgroundColor: Colors.BackgroundGray,
      color: Colors.Green,
      border: `1px solid ${Colors.Green}`
    }
  },
  muiinput: {
    padding:"10.5px 13.9px"
  }
  
} 
